module.exports = __webpack_public_path__ + "img/ocean_wave.7fd593ca.svg";